export default angular.module('MobileAppRateHelper', []);
